import { render, staticRenderFns } from "./AccordionBlockListItem.vue?vue&type=template&id=0f0895f0"
import script from "./AccordionBlockListItem.vue?vue&type=script&lang=ts"
export * from "./AccordionBlockListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports